module.exports = __webpack_public_path__ + "media/images/front/bg_1-219d7b6b641a013fae163c77a34c227f.webp";